var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { manageService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var NoticeService = /** @class */ (function (_super) {
    __extends(NoticeService, _super);
    function NoticeService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 多条件查询所有公告
     */
    NoticeService.prototype.findAllNotice = function (data, page, sort, loading) {
        return this.netService.send({
            server: manageService.noticeController.findAllNotice,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 新增公告
     */
    NoticeService.prototype.addNotice = function (data, loading) {
        return this.netService.send({
            server: manageService.noticeController.addNotice,
            data: data,
            loading: loading
        });
    };
    /**
     * 删除公告
     */
    NoticeService.prototype.deleteNotice = function (id, loading) {
        return this.netService.send({
            server: manageService.noticeController.deleteNotice,
            data: {
                id: id
            },
            loading: loading
        });
    };
    /**
     * 修改公告
     */
    NoticeService.prototype.modifyNotice = function (data, loading) {
        return this.netService.send({
            server: manageService.noticeController.modifyNotice,
            data: data,
            loading: loading
        });
    };
    /**
     * 首页公告列表查询
     */
    NoticeService.prototype.getNoticeList = function (loading) {
        return this.netService.send({
            server: manageService.noticeController.getNoticeList,
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], NoticeService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], NoticeService.prototype, "findAllNotice", null);
    __decorate([
        Debounce()
    ], NoticeService.prototype, "addNotice", null);
    __decorate([
        Debounce()
    ], NoticeService.prototype, "deleteNotice", null);
    __decorate([
        Debounce()
    ], NoticeService.prototype, "modifyNotice", null);
    __decorate([
        Debounce()
    ], NoticeService.prototype, "getNoticeList", null);
    return NoticeService;
}(Service));
export { NoticeService };
